import axios from "axios";
import Swal from "sweetalert2";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import "./Calendar.css";
import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import { Button, TextField } from "@mui/material";
import { Box } from "@mui/system";
import FormControl from '@mui/material/FormControl';
import {
  Link,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  Modal,
} from "@mui/material";
import Search from "./Search";

const stylee = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  bgcolor: "white",
  border: "1px solid #e79129",
  boxShadow: 24,
  p: 1,
};

const styleee = {
  position: "absolute",
  top: "50%",
  left: "50%",
  width: 900,
  height: 900,
  transform: "translate(-50%, -50%)",
  bgcolor: "white",
  border: "1px solid #e79129",
  boxShadow: 24,
  p: 1,
};


const Article = () => {
  const textnull = ""

  //ตรวจสอบนัด
  const [openappointment, setOpenappointment] = useState(false);
  const handleOpenappointment = () => setOpenappointment(true);
  const handleCloseappointment = () => setOpenappointment(false);
  //ตรวจสอบนัด

  //ยกเลิกนัด
  const [opencancelappointment, setOpencancelappointment] = useState(false);
  const handleOpencancelappointment = () => setOpencancelappointment(true);
  const handleClosecancelappointment = () => setOpencancelappointment(false);
  //ยกเลิกนัด

  //เกี่ยวกับเรา
  const [openabout, setOpenabout] = useState(false);
  const handleOpenabout = () => setOpenabout(true);
  const handleCloseabout = () => setOpenabout(false);
  //เกี่ยวกับเรา

  //ความพึงพอใจ
  const [openSatisfied, setOpenSatisfied] = useState(false);
  const handleOpenSatisfied = () => setOpenSatisfied(true);
  const handleCloseSatisfied = () => {
    // setOpenSatisfied(false)
    setBusiness("")
    setDepartment(null)
    setAge("")
    setSex("")
    setScore11(null)
    setScore12(null)
    setScore13(null)
    setScore21(null)
    setScore22(null)
    setScore23(null)
    setScore24(null)
    setScore25(null)
    setScore26(null)
    setScore27(null)
    setScore31(null)
    setScore32(null)
    setScore33(null)
    setScore34(null)
    setScore41(null)
    setGood("")
    setBad("")
    return
  }
  const handleSubmitsend = () => {
    setBusiness("")
    setDepartment(null)
    setAge("")
    setSex("")
    setScore11(null)
    setScore12(null)
    setScore13(null)
    setScore21(null)
    setScore22(null)
    setScore23(null)
    setScore24(null)
    setScore25(null)
    setScore26(null)
    setScore27(null)
    setScore31(null)
    setScore32(null)
    setScore33(null)
    setScore34(null)
    setScore41(null)
    setGood("")
    setBad("")
    return
  }
  //ความพึงพอใจ

  //แผนก
  const [department, setDepartment] = useState(null);
  const handleChangedepartment = (event) => {
    setDepartment(event.target.value);
  };
  //แผนก

  //เพศ
  const [sex, setSex] = useState(null);
  const handleChangesex = (event) => {
    setSex(event.target.value);
  };
  //เพศ

  //อายุ
  const [age, setAge] = useState(null);
  const handleChangeage = (event) => {
    setAge(event.target.value);
  };
  //อายุ

  //อาชีพ
  const [business, setBusiness] = useState(null);
  const handleChangebusiness = (event) => {
    setBusiness(event.target.value);
  };
  //อาชีพ

  //แบบประเมิน
  const [score11, setScore11] = useState(null);
  const [score12, setScore12] = useState(null);
  const [score13, setScore13] = useState(null);
  const [score21, setScore21] = useState(null);
  const [score22, setScore22] = useState(null);
  const [score23, setScore23] = useState(null);
  const [score24, setScore24] = useState(null);
  const [score25, setScore25] = useState(null);
  const [score26, setScore26] = useState(null);
  const [score27, setScore27] = useState(null);
  const [score31, setScore31] = useState(null);
  const [score32, setScore32] = useState(null);
  const [score33, setScore33] = useState(null);
  const [score34, setScore34] = useState(null);
  const [score41, setScore41] = useState(null);
  //แบบประเมิน

  //ข้อเสนอแนะ
  const [good, setGood] = useState("");
  const [bad, setBad] = useState("");
  //ข้อเสนอแนะ

  const handleChangeallscore = (event) => {
    setScore11(event.target.value)
    setScore12(event.target.value)
    setScore13(event.target.value)
    setScore21(event.target.value)
    setScore22(event.target.value)
    setScore23(event.target.value)
    setScore24(event.target.value)
    setScore25(event.target.value)
    setScore26(event.target.value)
    setScore27(event.target.value)
    setScore31(event.target.value)
    setScore32(event.target.value)
    setScore33(event.target.value)
    setScore34(event.target.value)
    setScore41(event.target.value)
  };

  const handleOpen = () => {
    Swal.fire({
      icon: "info",
      title: "ระบบยังไม่เปิดให้บริการ",
      showConfirmButton: false,
      timer: 4000,
    }).then((result) => {
      return;
    });
  };


  const submitSatisfied = (e) => {
    const loading = true
    const showloading =()=>{
      if(loading){
        Swal.fire({
          title: 'Please Wait !',
          html: 'data uploading',
          allowOutsideClick: false,
          showConfirmButton: false,
          timer:3000,
          willOpen: () => {
              Swal.showLoading()
          },
      })
      }
    }
    const sheetURL = 'https://script.google.com/macros/s/AKfycbzzB6G6XrvdXeK-_vWA6MgFqnb7DEN6lsM2AZ_tsk-YCW8efRJsPgZ3_O74R011sH9L/exec?'
    const data1 = `data1=${department}`
    const data2 = `&data2=${sex}`
    const data3 = `&data3=${age}`
    const data4 = `&data4=${business}`
    const data5 = `&data5=${score11}`
    const data6 = `&data6=${score12}`
    const data7 = `&data7=${score13}`
    const data8 = `&data8=${score21}`
    const data9 = `&data9=${score22}`
    const data10 = `&data10=${score23}`
    const data11 = `&data11=${score24}`
    const data12 = `&data12=${score25}`
    const data13 = `&data13=${score26}`
    const data14 = `&data14=${score27}`
    const data15 = `&data15=${score31}`
    const data16 = `&data16=${score32}`
    const data17 = `&data17=${score33}`
    const data18 = `&data18=${score34}`
    const data19 = `&data19=${score41}`
    const data20 = `&data20=${good}`
    const data21 = `&data21=${bad}`
    e.preventDefault();
    showloading()
    axios.get(`${sheetURL}${data1}${data2}${data3}${data4}${data5}${data6}${data7}${data8}${data9}${data10}${data11}${data12}${data13}${data14}${data15}${data16}${data17}${data18}${data19}${data20}${data21}`).then((res) => {
        if (res.data.result === 'nodata') {
          Swal.fire({
            icon: "error",
            title: "มีข้อผิดพลาด",
            showConfirmButton: false,
            timer: 2000,
          }).then((result) => {
            handleSubmitsend()
            return;
          });
        }
        else if (res.data.result === 'added') {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลเรียบร้อย",
            text: 'คลินิกการแพทย์แผนไทย โรงพยาบาลสุไหงปาดี ขอบคุณค่ะ',
            showConfirmButton: false,
            timer: 2000,
          }).then((result) => {
            handleSubmitsend()
            return;
          });
        }
    })
  };

  //ติชม
  const [openfeedback, setOpenfeedback] = useState(false);
  const handleOpenfeedback = () => setOpenfeedback(true);
  const handleClosefeedback = () => setOpenfeedback(false);
  //ติชม

  //กลุ่มไลน์
  const [opengroupline, setOpengroupline] = useState(false);
  const handleOpengroupline = () => setOpengroupline(true);
  const handleClosegroupline = () => setOpengroupline(false);
  //กลุ่มไลน์

  //ไลน์oa
  const [openlineoa, setOpenlineoa] = useState(false);
  const handleOpenlineoa = () => setOpenlineoa(true);
  const handleCloselineoa = () => setOpenlineoa(false);
  //ไลน์oa




  return (
    <Paper style={{ padding: '30px', border: 'solid 1.5px #e79129' }}>
      <Grid container spacing={3}>
        <Search/>
        <Search/>
        <Grid item xs={4} >
          <Paper style={{ backgroundColor: '#18b1b7' }}>
            <Link
              component="button"
              onClick={handleOpenlineoa}
              underline="none"
              className="article"
            >
              <h1 style={{ color: 'white' }}>LINE OA</h1>
            </Link>
            <Modal
              open={openlineoa}
              onClose={handleCloselineoa}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={stylee}>
                <Paper style={{ padding: '50px' }}>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img style={{height:'500px'}} className='groupline' src="/lineoa.png" alt="" />
                  </div>
                  <div>
                    <Button
                      style={{ marginTop: '20px' }}
                      fullWidth
                      variant="contained"
                      color="warning"
                      onClick={handleCloselineoa}
                    >
                      <h2>ปิด</h2>
                    </Button>
                  </div>
                </Paper>
              </Box>
            </Modal>
          </Paper>
        </Grid>
        <Grid item xs={4} >
          <Paper style={{ backgroundColor: '#18b1b7' }}>
            <Link
              component="button"
              onClick={handleOpenSatisfied}
              underline="none"
              className="article"
            >
              <h1 style={{ color: 'white' }}>ประเมินความพึงพอใจ</h1>
            </Link>
            <Modal
              open={openSatisfied}
              onClose={handleCloseSatisfied}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={stylee}>
                <form onSubmit={submitSatisfied}>
                  <div style={{ width: '100%', marginTop: '5px', marginBottom: '5px', textAlign: 'center' }}>
                    {/* <img className='logohospital' style={{ width: '20%' }} src="/logohospital.png" alt="" /> */}
                    <h1>แบบประเมินความพึงพอใจต่อการให้บริการ</h1>
                    <h1>โรงพยาบาลสุไหงปาดี</h1>
                  </div>
                  <Paper>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableBody>
                          <TableRow >
                            <TableCell style={{ border: 'none' }} colSpan={2} align="center"><h2>แผนกที่ต้องการประเมิน</h2></TableCell>
                          </TableRow>
                        </TableBody>
                        <TableBody>
                          <TableRow>
                            <TableCell style={{ border: 'none' }} align="center">
                              <input required={department === null} type="checkbox" checked={department === '12. แพทย์แผนไทย'} onChange={e => setDepartment(e.target.value)} value="12. แพทย์แผนไทย"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                              <h2>แผนกการแพทย์แผนไทย</h2>
                            </TableCell>
                            <TableCell style={{ border: 'none' }} align="center">
                              <input required={department === null} type="checkbox" checked={department === '13. กายภาพบำบัด'} onChange={e => setDepartment(e.target.value)} value="13. กายภาพบำบัด"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              /><h2>แผนกกายภาพบำบัด</h2>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                  <Paper style={{ padding: '20px', marginBottom: '5px' }}>
                    <div>
                      <h2>ข้อมูลทั่วไป</h2>
                    </div>
                    <div>
                      <Grid container spacing={3}>
                        <Grid item xs={4} >
                          <FormControl variant="standard" fullWidth >
                            <InputLabel style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} id="demo-simple-select-standard-label">
                              <h2>เพศ</h2>
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-standard-label"
                              id="demo-simple-select-standard"
                              required={sex === null || sex === ""}
                              value={sex}
                              onChange={handleChangesex}
                              label="เพศ"
                            >
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="ชาย"><h2> ชาย</h2></MenuItem>
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="หญิง"><h2>หญิง</h2></MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={4} >
                          <FormControl variant="standard" fullWidth>
                            <InputLabel style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} id="demo-simple-select-standard-label">
                              <h2>อายุ</h2>
                            </InputLabel>
                            <Select
                              required={age === null || age === ""}
                              style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }}
                              labelId="demo-simple-select-standard-label"
                              id="demo-simple-select-standard"
                              value={age}
                              onChange={handleChangeage}
                              label="อายุ"
                            >
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="ต่ำกว่า&nbsp;18&nbsp;ปี"><h2>ต่ำกว่า 18 ปี</h2></MenuItem>
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="18&nbsp;-&nbsp;35&nbsp;ปี"><h2>18 - 35 ปี</h2></MenuItem>
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="36&nbsp;-&nbsp;60&nbsp;ปี"><h2>36 - 60 ปี</h2></MenuItem>
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="61&nbsp;ปีขึ้นไป"><h2>61 ปีขึ้นไป</h2></MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={4} >
                          <FormControl variant="standard" fullWidth>
                            <InputLabel style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} id="demo-simple-select-standard-label">
                              <h2>อาชีพ</h2>
                            </InputLabel>
                            <Select
                              required={business === null || business === ""}
                              style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }}
                              labelId="demo-simple-select-standard-label"
                              id="demo-simple-select-standard"
                              value={business}
                              onChange={handleChangebusiness}
                              label="อาชีพ"
                            >
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="รับจ้าง"><h2>รับจ้าง</h2></MenuItem>
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="เกษตรกร"><h2>เกษตรกร</h2></MenuItem>
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="ธุรกิจส่วนตัว"><h2>ธุรกิจส่วนตัว</h2></MenuItem>
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="พนักงานบริษัท"><h2>พนักงานบริษัท</h2></MenuItem>
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="ข้าราชการ"><h2>ข้าราชการ</h2></MenuItem>
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="พนักงานรัฐวิสาหกิจ"><h2>พนักงานรัฐวิสาหกิจ</h2></MenuItem>
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="นักเรียน/นักศึกษา"><h2>นักเรียน/นักศึกษา</h2></MenuItem>
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="ว่างงาน"><h2>ว่างงาน</h2></MenuItem>
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="แม่บ้าน"><h2>แม่บ้าน</h2></MenuItem>
                              <MenuItem style={{ fontFamily: 'Athiti, sans-serif', fontWeight: 'bold' }} value="อื่น ๆ"><h2>อื่น ๆ</h2></MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </div>
                  </Paper>
                  <Paper style={{ padding: '20px' }}>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={6} style={{ border: 'none' }} align="center"><h3>คำชี้แจง: 5 หมายถึง มากที่สุด , 4 หมายถึง มาก , 3 หมายถึง ปานกลาง , 2 หมายถึง น้อย , 1 หมายถึง น้อยที่สุด </h3></TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ border: 'none' }} align="center"><h2>{textnull}</h2></TableCell>
                            <TableCell style={{ border: 'none' }} align="center">
                              <input type="checkbox" checked={false} onChange={handleChangeallscore} value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell style={{ border: 'none' }} align="center">
                              <input
                                type="checkbox"
                                checked={false}
                                onChange={handleChangeallscore}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell style={{ border: 'none' }} align="center">
                              <input
                                type="checkbox"
                                checked={false}
                                onChange={handleChangeallscore}
                                value="3"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              /></TableCell>
                            <TableCell style={{ border: 'none' }} align="center">
                              <input
                                type="checkbox"
                                checked={false}
                                onChange={handleChangeallscore}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell style={{ border: 'none' }} align="center">
                              <input
                                type="checkbox"
                                checked={false}
                                onChange={handleChangeallscore}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center"><h2>ด้านพฤติกรรมบริการ</h2></TableCell>
                            <TableCell align="center"><h2>5</h2></TableCell>
                            <TableCell align="center"><h2>4</h2></TableCell>
                            <TableCell align="center"><h2>3</h2></TableCell>
                            <TableCell align="center"><h2>2</h2></TableCell>
                            <TableCell align="center"><h2>1</h2></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell style={{ width: '520px' }}><h3>1. เจ้าหน้าที่สุภาพ นุ่มนวล ยิ้มแย้ม วาจาสุภาพ</h3></TableCell>
                            <TableCell align="center">
                              <input required={score11 === null} type="checkbox" checked={score11 === '5'} onChange={e => setScore11(e.target.value)} value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score11 === '4'}
                                onChange={e => setScore11(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score11 === '3'}
                              onChange={e => setScore11(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score11 === '2'}
                                onChange={e => setScore11(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score11 === '1'}
                                onChange={e => setScore11(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: '500px' }}><h3>2. เจ้าหน้าที่สนใจ เอาใจใส่และเต็มใจให้ความช่วยเหลือสม่ำเสมอ</h3></TableCell>
                            <TableCell align="center">
                              <input
                                required={score12 === null}
                                type="checkbox"
                                checked={score12 === '5'}
                                onChange={e => setScore12(e.target.value)}
                                value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score12 === '4'}
                                onChange={e => setScore12(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score12 === '3'}
                              onChange={e => setScore12(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score12 === '2'}
                                onChange={e => setScore12(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score12 === '1'}
                                onChange={e => setScore12(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: '500px' }}><h3>3. เจ้าหน้าที่ให้ความช่วยเหลือทันที เมื่อท่านต้องการ</h3></TableCell>
                            <TableCell align="center">
                              <input
                                required={score13 === null}
                                type="checkbox"
                                checked={score13 === '5'}
                                onChange={e => setScore13(e.target.value)}
                                value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score13 === '4'}
                                onChange={e => setScore13(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score13 === '3'}
                              onChange={e => setScore13(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score13 === '2'}
                                onChange={e => setScore13(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score13 === '1'}
                                onChange={e => setScore13(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                        <TableHead>
                          <TableRow>
                            <TableCell align="center"><h2>ด้านการให้บริการ</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell style={{ width: '500px' }}><h3>4. ขั้นตอนการให้บริการไม่ยุ่งยาก</h3></TableCell>
                            <TableCell align="center">
                              <input type="checkbox" required={score21 === null} checked={score21 === '5'} onChange={e => setScore21(e.target.value)} value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score21 === '4'}
                                onChange={e => setScore21(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score21 === '3'}
                              onChange={e => setScore21(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score21 === '2'}
                                onChange={e => setScore21(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score21 === '1'}
                                onChange={e => setScore21(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: '500px' }}><h3>5. ได้รับบริการสะดวก และรวดเร็ว</h3></TableCell>
                            <TableCell align="center">
                              <input
                                required={score22 === null}
                                type="checkbox"
                                checked={score22 === '5'}
                                onChange={e => setScore22(e.target.value)}
                                value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score22 === '4'}
                                onChange={e => setScore22(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score22 === '3'}
                              onChange={e => setScore22(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score22 === '2'}
                                onChange={e => setScore22(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score22 === '1'}
                                onChange={e => setScore22(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: '500px' }}><h3>6. ให้บริการตามลำดับก่อนหลัง</h3></TableCell>
                            <TableCell align="center">
                              <input
                                required={score23 === null}
                                type="checkbox"
                                checked={score23 === '5'}
                                onChange={e => setScore23(e.target.value)}
                                value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score23 === '4'}
                                onChange={e => setScore23(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score23 === '3'}
                              onChange={e => setScore23(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score23 === '2'}
                                onChange={e => setScore23(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score23 === '1'}
                                onChange={e => setScore23(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: '500px' }}><h3>7. ให้บริการอย่างเท่าเทียม ไม่เลือกปฏิบัติ</h3></TableCell>
                            <TableCell align="center">
                              <input
                                required={score24 === null}
                                type="checkbox"
                                checked={score24 === '5'}
                                onChange={e => setScore24(e.target.value)}
                                value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score24 === '4'}
                                onChange={e => setScore24(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score24 === '3'}
                              onChange={e => setScore24(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score24 === '2'}
                                onChange={e => setScore24(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score24 === '1'}
                                onChange={e => setScore24(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: '500px' }}><h3>8. เจ้าหน้าที่ให้ข้อมูล และคำแนะนำในการปฏิบัติตนและสามารถดูแลตนเองได้</h3></TableCell>
                            <TableCell align="center">
                              <input
                                required={score25 === null}
                                type="checkbox"
                                checked={score25 === '5'}
                                onChange={e => setScore25(e.target.value)}
                                value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score25 === '4'}
                                onChange={e => setScore25(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score25 === '3'}
                              onChange={e => setScore25(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score25 === '2'}
                                onChange={e => setScore25(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score25 === '1'}
                                onChange={e => setScore25(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: '500px' }}><h3>9. เจ้าหน้าที่มีความรู้ความสามารถในการให้บริการ</h3></TableCell>
                            <TableCell align="center">
                              <input
                                required={score26 === null}
                                type="checkbox"
                                checked={score26 === '5'}
                                onChange={e => setScore26(e.target.value)}
                                value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score26 === '4'}
                                onChange={e => setScore26(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score26 === '3'}
                              onChange={e => setScore26(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score26 === '2'}
                                onChange={e => setScore26(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score26 === '1'}
                                onChange={e => setScore26(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: '500px' }}><h3>10. เจ้าหน้าที่ช่วยให้ท่านบรรเทาความเจ็บปวด และความทุกข์ทรมาน</h3></TableCell>
                            <TableCell align="center">
                              <input
                                required={score27 === null}
                                type="checkbox"
                                checked={score27 === '5'}
                                onChange={e => setScore27(e.target.value)}
                                value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score27 === '4'}
                                onChange={e => setScore27(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score27 === '3'}
                              onChange={e => setScore27(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score27 === '2'}
                                onChange={e => setScore27(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score27 === '1'}
                                onChange={e => setScore27(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                        <TableHead>
                          <TableRow>
                            <TableCell align="center"><h2>ด้านอาคารสถานที่และเครื่องมือ</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell style={{ width: '500px' }}><h3>11. สถานที่ที่ท่านใช้บริการมีความปลอดภัย</h3></TableCell>
                            <TableCell align="center">
                              <input required={score31 === null} type="checkbox" checked={score31 === '5'} onChange={e => setScore31(e.target.value)} value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score31 === '4'}
                                onChange={e => setScore31(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score31 === '3'}
                              onChange={e => setScore31(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score31 === '2'}
                                onChange={e => setScore31(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score31 === '1'}
                                onChange={e => setScore31(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: '500px' }}><h3>12. สถานที่ที่ท่านใช้บริการมีความสะอาด อากาศถ่ายเทและไม่มีกลิ่น</h3></TableCell>
                            <TableCell align="center">
                              <input
                                required={score32 === null}
                                type="checkbox"
                                checked={score32 === '5'}
                                onChange={e => setScore32(e.target.value)}
                                value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score32 === '4'}
                                onChange={e => setScore32(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score32 === '3'}
                              onChange={e => setScore32(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score32 === '2'}
                                onChange={e => setScore32(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score32 === '1'}
                                onChange={e => setScore32(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: '500px' }}><h3>13. อุปกรณ์ของใช้ที่ให้บริการ สะอาด เพียงพอ ทันสมัย และพร้อมใช้</h3></TableCell>
                            <TableCell align="center">
                              <input
                                required={score33 === null}
                                type="checkbox"
                                checked={score33 === '5'}
                                onChange={e => setScore33(e.target.value)}
                                value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score33 === '4'}
                                onChange={e => setScore33(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score33 === '3'}
                              onChange={e => setScore33(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score33 === '2'}
                                onChange={e => setScore33(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score33 === '1'}
                                onChange={e => setScore33(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: '500px' }}><h3>14. สิ่งอำนวยความสะดวกโดยรวม เช่น ห้องน้ำ ที่จอดรถ โรงอาหาร ป้ายบอกทาง</h3></TableCell>
                            <TableCell align="center">
                              <input
                                required={score34 === null}
                                type="checkbox"
                                checked={score34 === '5'}
                                onChange={e => setScore34(e.target.value)}
                                value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score34 === '4'}
                                onChange={e => setScore34(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score34 === '3'}
                              onChange={e => setScore34(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score34 === '2'}
                                onChange={e => setScore34(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score34 === '1'}
                                onChange={e => setScore34(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                        <TableHead>
                          <TableRow>
                            <TableCell align="center"><h2>ด้านความพึงพอใจภาพรวม</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                            <TableCell align="center"><h2>{textnull}</h2></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell style={{ width: '500px' }}><h3>15. ในภาพรวมความพึงพอใจในบริการที่ได้รับครั้งนี้</h3></TableCell>
                            <TableCell align="center">
                              <input
                                required={score41 === null}
                                type="checkbox"
                                checked={score41 === '5'}
                                onChange={e => setScore41(e.target.value)}
                                value="5"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score41 === '4'}
                                onChange={e => setScore41(e.target.value)}
                                value="4"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">                          <input
                              type="checkbox"
                              checked={score41 === '3'}
                              onChange={e => setScore41(e.target.value)}
                              value="3"
                              style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                            /></TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score41 === '2'}
                                onChange={e => setScore41(e.target.value)}
                                value="2"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <input
                                type="checkbox"
                                checked={score41 === '1'}
                                onChange={e => setScore41(e.target.value)}
                                value="1"
                                style={{ height: '22px', width: '22px', verticalAlign: 'bottom' }}
                              />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                  <Paper style={{ padding: '20px', marginBottom: '5px' }}>
                      <TextField
                      label="สิ่งที่น่าประทับใจ (กรุณาเขียนเพิ่มเติม)"
                      variant="filled"
                      fullWidth
                      onChange={(event) => {
                        setGood(event.target.value);
                      }}
                      value={good}
                      style={{marginBottom:'10px'}}
                    />
                    <TextField
                      label="สิ่งที่ไม่ประทับใจและควรปรับปรุง (กรุณาเขียนเพิ่มเติม)"
                      variant="filled"
                      fullWidth
                      onChange={(event) => {
                        setBad(event.target.value);
                      }}
                      value={bad}
                    />
                  </Paper>
                  <Paper style={{ padding: '20px' }}>
                    <Grid container spacing={2}>
                      <Grid item xs={8}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="success"
                          fullWidth
                        >
                          <h1>ยืนยัน</h1>
                        </Button>
                      </Grid>
                      <Grid item xs={4}>
                        <Button
                          fullWidth
                          variant="contained"
                          color="warning"
                          onClick={handleCloseSatisfied}
                        >
                          <h1>ยกเลิก</h1>
                        </Button>
                      </Grid>
                    </Grid>
                  </Paper>
                </form>
              </Box>
            </Modal>
          </Paper>
        </Grid>
        <Grid item xs={4} >
          <Paper style={{ backgroundColor: '#18b1b7' }}>
            <Link
              component="button"
              onClick={handleOpenfeedback}
              underline="none"
              className="article"
            >
              <h1 style={{ color: 'white' }}>ติชมและร้องเรียน</h1>
            </Link>
            <Modal
              open={openfeedback}
              onClose={handleClosefeedback}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description">
                <Box sx={styleee}>
                <Paper style={{width:'100%',height:'100%'}}>
                <iframe
                  style={{width:'100%',height:'100%'}}
                  src="https://docs.google.com/forms/d/e/1FAIpQLSf2HlHRDooAeE2FfhS7NL-mquxatYHDGuDKeh6a_1WUqBe5tA/viewform"
                />
                </Paper>
                </Box>
            </Modal>
          </Paper>
        </Grid>
        <Grid item xs={4} >
          <Paper style={{ backgroundColor: '#18b1b7' }}>
            <Link
              component="button"
              onClick={handleOpengroupline}
              underline="none"
              className="article"
            >
              <h1 style={{ color: 'white' }}>กลุ่มไลน์ผู้รับบริการ</h1>
            </Link>
            <Modal
              open={opengroupline}
              onClose={handleClosegroupline}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={stylee}>
                <Paper style={{ padding: '50px' }}>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img style={{height:'500px'}} className='groupline' src="/groupline.png" alt="" />
                  </div>
                  <div>
                    <Button
                      style={{ marginTop: '20px' }}
                      fullWidth
                      variant="contained"
                      color="warning"
                      onClick={handleClosegroupline}
                    >
                      <h2>ปิด</h2>
                    </Button>
                  </div>
                </Paper>
              </Box>
            </Modal>
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  );
};
export default Article;
